var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "divBox normal-page" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "left" }, [
          _c("i", {
            staticClass: "el-icon-arrow-left",
            on: { click: _vm.goBack },
          }),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.info.name || "--")),
            ]),
            _vm._v(" "),
            _c(
              "el-tabs",
              {
                staticClass: "tab",
                on: { "tab-click": _vm.tabChange },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c("el-tab-pane", { attrs: { label: "任务详情", name: "1" } }),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { label: "项目资料", name: "2" } }),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { label: "项目动态", name: "3" } }),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { label: "项目设置", name: "4" } }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.activeName == 1
        ? _c(
            "div",
            [
              _c("task", {
                ref: "taskDrawerRef",
                attrs: { programId: Number(_vm.id), isDrawer: true },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeName == 2
        ? _c("div", [_c("files", { attrs: { programId: _vm.info.id } })], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.activeName == 3
        ? _c("div", [_c("dynamics", { attrs: { programId: _vm.info.id } })], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.activeName == 4
        ? _c(
            "div",
            [
              _c("add-program", {
                attrs: { type: _vm.type, formInfo: _vm.info },
                on: { goBack: _vm.goBack, getProgramInfo: _vm.getProgramInfo },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "invoice-logo" }, [
      _c("i", { staticClass: "icon iconfont iconhetong" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }